import React from "react";

import {FormTextInput} from "UIComponents/InputTextField";

import classes from "./Step1.scss";

const Step1 = props => {
  const { data, updateInputField } = props;
  const { email, password } = data;

  return (
    <div className={classes.inputsContainer}>
      <div className={classes.inputContainer}>
        <FormTextInput
          textInputLabel={"Email"}
          value={email}
          name={"email"}
          placeholder={"Enter your email"}
          disabled={true}
          size={"large"}
        />
      </div>
      <div className={classes.inputContainer}>
        <FormTextInput
          textInputLabel={"Create password*"}
          placeholder={"Enter password"}
          name={"password"}
          value={password}
          type={"password"}
          updateInputField={updateInputField}
          size={"large"}
          error={"Enter password"}
          isRequired={true}
        />
      </div>
    </div>
  );
};

export default Step1;
